import { css } from '@mui/styled-engine'

import type { HAVDesignTokensInterface } from '../interfaces'
import { havDefault02Text } from './Texts'

const havTag = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  color: ${HAVDesignTokens.palette.neutral.white};
  ${havDefault02Text(HAVDesignTokens)};
  text-transform: ${HAVDesignTokens.typography.text.decoration.uppercase};

  @media (max-width: 767px) {
    font-size: ${HAVDesignTokens.typography.font.size.xx.small};
  }

  background-color: ${HAVDesignTokens.palette.main.tertiary};
  border-radius: ${HAVDesignTokens.shape.border.radius.small};
  padding: ${`${HAVDesignTokens.spacing.padding.height.small}
    ${HAVDesignTokens.spacing.padding.lenght.xsmall}`};
`

export { havTag }
